import React, { Fragment } from 'react'
import Session from '../services/Session'
import { base } from "../fire";
import { Spinner } from '@blueprintjs/core'
import logo from '../assets/logo.png'
import session from '../services/Session'
import Header from '../components/publicResults/Header'
import GeneralResults from '../components/publicResults/GeneralResults'
import BarResults from '../components/publicResults/BarResults'
import "../assets/components/Result.css";
import FadeIn from 'react-fade-in'
import { changeLanguage } from "utlis/translations/i18n";



class PublicResults extends React.Component {
    constructor(props) {
        super(props);
        this.state = { session: null, instances: [], loading: true };
        this.sessionId = this.props.match.params.id;
    }

    handleFormatResults = () => {
        let formatedResults = session.getResultsForSession(this.state.session, this.state.instances)
        this.setState({ formatedResults, loading: false })
    }

    componentDidMount() {
        /**
         * TODO: Check if we don't have the same issue that we had on user
         * (because we set sessionId in constructor and we need a refresh to update the value)
         */
        Session.getSessionByIdAndAuthID(this.sessionId).then(session => {
            if (!session) return this.setState({ loading: false, session: null });
            this.setState({ session });
            if (session.metadata.language) {
                changeLanguage(session.metadata.language);
              }
            this.syncSessionInstances = Session.syncSessionInstances(session.id, {
                context: this,
                state: "instances",
                asArray: true,
                then: () => {
                    this.handleFormatResults()
                }
            });
        });

        document.body.style.background = "#dddddd";
        // document.body.style.background =
        //     "-webkit-linear-gradient(to right, #232526, #414345)";
        // document.body.style.background =
        //     "linear-gradient(to right, #232526, #414345)";
    }

    componentWillUnmount() {
        document.body.style.background = null;

        if (this.syncSessionInstances)
            base.removeBinding(this.syncSessionInstances);
    }


    render() {

        if (this.state.instances && this.state.session) {
            const { session, formatedResults } = this.state
            const {
                data,
                metadata } = session
            let totalVotes = 0
            if (formatedResults && formatedResults[0]) {
                formatedResults[0].results.forEach((res) => {
                    totalVotes = totalVotes + res.points
                })
            }


            return (
                <div className='publicResultBody'>
                    <div className="context text-center margin-top-medium vs-container-personal-questions">
                        <div className='logo-container'>
                            <img src={logo} alt="logo" className='logo-large' />  &nbsp; &nbsp;
                                <span className='logo-title-large'>VisualSense</span>
                        </div>
                    </div>
                    {metadata &&
                        <Fragment>
                            {totalVotes !== 0 ?
                                <FadeIn>
                                    <Header
                                        title={metadata.name}
                                        context={metadata.context}
                                        votesAmount={totalVotes}
                                    />
                                </FadeIn>
                                :
                                ''
                            }

                            {formatedResults &&
                                <Fragment>
                                    <FadeIn className='margin-top-large'>
                                        <BarResults
                                            results={formatedResults}
                                            sequences={data.sequences}
                                        />
                                    </FadeIn>
                                    {formatedResults.slice(0).reverse().map((results, i) => {
                                        let descendingResults = results.results.sort((a, b) => {
                                            if (a.points > b.points) return -1;
                                            if (a.points < b.points) return 1;
                                            return 0;
                                        })
                                        return (
                                            <FadeIn key={i}>
                                                <GeneralResults
                                                    sequence={data.sequences.find(sequence => sequence.id === results.sequenceId)}
                                                    results={descendingResults}
                                                />
                                            </FadeIn>
                                        )
                                    }
                                    )}
                                </Fragment>
                            }
                        </Fragment>
                    }
                </div>
            )
        }

        return (
            <div style={{ marginTop: "50px" }}>
                <Spinner size={200} />
            </div>)
    }
}

export default PublicResults
